import React, { Component } from 'react';
import './ActivityTracker.css';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import CurrentGoal from './../ActivityTracker/CurrentGoal';

class CurrentGoalSummary extends Component {
    constructor(props){
        super(props);
        this.state = {

        };
    }

    render(){

        return (
            <div className={'activity-summary-container'}>
                <CurrentGoal align={'left'} value={this.props.dayValue} goal={this.props.dayGoal} name={'Daily'} color={'red'} />
                <CurrentGoal align={'center'} value={this.props.weekValue} goal={this.props.weekGoal} name={'Weekly'} color={'green'} />
                <CurrentGoal align={'right'} value={this.props.monthValue} goal={this.props.monthGoal} name={'Monthly'} color={'blue'} />
            </div>
        )
    }
}

export default CurrentGoalSummary;



// WEBPACK FOOTER //
// ./src/Components/ActivityTracker/CurrentGoalSummary.js